import { getConfig } from "./featureSwitch";
const defaultConfig = {
    emptyImageUrl: '/images/empty.png',
    replacements: []
};
const probiblioToSdi = {
    replace: 'probiblio.hostedwise.nl',
    with: 'bibliotheek.wise.oclc.org'
};
const imageConfigs = {
    vbp: defaultConfig,
    aanzet: {
        ...defaultConfig,
        replacements: [
            probiblioToSdi
        ]
    },
    bkw: {
        ...defaultConfig,
        replacements: [
            probiblioToSdi
        ]
    },
    dnb: defaultConfig,
    flevo: defaultConfig,
    rdam: defaultConfig,
    twente: defaultConfig
};
export const imageConfig = getConfig(imageConfigs);
